import { getQrCode, getEmailService, customerDetailsApi } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const SuccessPageAction  = {
    QR_CODE_SUCCESS : 'QR_CODE_SUCCESS',
    QR_CODE_FAILURE : 'QR_CODE_FAILURE',
    EMAIL_SERVICE_SUCCESS : 'EMAIL_SERVICE_SUCCESS',
    EMAIL_SERVICE_FAILURE : 'EMAIL_SERVICE_FAILURE',
    GET_CUSTOMER_DETAILS_SUCCESS : 'GET_CUSTOMER_DETAILS_SUCCESS',
    GET_CUSTOMER_DETAILS_FAILURE : 'GET_CUSTOMER_DETAILS_FAILURE'
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];
let getQrCodeDetailsCounter = 0;

const getQrCodeDetails:any = (orderId: any,customerId:any) => {
    return function (dispatch: any) {
        getQrCode(orderId,customerId)
            .then((response) => {
                dispatch({ type: SuccessPageAction.QR_CODE_SUCCESS, payload: response.data });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'getQRCode' });
                const error = { ...err, config };
                if (error?.response?.status) {
                                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                            } else {
                                ++getQrCodeDetailsCounter
                                if (getQrCodeDetailsCounter < retryCount) {
                                    const objData = JSON.parse(error?.config?.data);
                                    dispatch(getQrCodeDetails(objData?.OrderId,customerId));
                                } else {
                                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                                }
                            }
            })
    }
}

const emailServiceDetails:any = (orderId: any, email: any,customerId:any) => {
    return function (dispatch: any) {
        getEmailService(orderId, email,customerId)
            .then((response) => {
                dispatch({  type: SuccessPageAction.EMAIL_SERVICE_SUCCESS, payload: response  });
            })
                .catch((error) => {
                    //Display error
                const config = Object.assign(error.config, { serviceName: 'sendQRCode' });
                    dispatch({  type: SequenceManagerAction.GENERIC_ERROR, payload: { ... error, config }  });
                })
    }
}

const getCustomerDetailsSSA = (msisdn: any) => {
    return function (dispatch: any) {
        customerDetailsApi(msisdn).then((response) => {
            console.log(response);
            dispatch({ type: SuccessPageAction.GET_CUSTOMER_DETAILS_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}


export { SuccessPageAction, getQrCodeDetails, emailServiceDetails, getCustomerDetailsSSA };